import { render, staticRenderFns } from "./group-disabled.mpx?vue&type=template&id=6e5e79ba&isComponent&outputPath=components%2Fgroup-disabled34808362%2Findex"
import script from "./group-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fgroup-disabled34808362%2Findex"
export * from "./group-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fgroup-disabled34808362%2Findex"
import style0 from "./group-disabled.mpx?vue&type=style&index=0&id=6e5e79ba&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_34808362%22%7D&isComponent&outputPath=components%2Fgroup-disabled34808362%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports